<template>
  <div class="cutsom_container">
    <div class="row">
      <br />
      <div class="col m6">
        <back-container
          :link="'/patient/dots/edit/' + $route.params.id"
        ></back-container>
        <visit-date-detail
          @close="detailShow = false"
          v-bind:show="detailShow"
          v-bind:detailData="detailData"
        ></visit-date-detail>
        <date-edit-modal
          @close="dateEditShow = false"
          v-bind:show="dateEditShow"
          v-bind:detailData="detailData"
        ></date-edit-modal>
        <edit-dots-visit-data
          @close="editInfoModalShow = false"
          v-bind:show="editInfoModalShow"
          v-bind:detailData="detailData"
        ></edit-dots-visit-data>

        <router-link
          v-show="
            data.patient &&
            data.patient.finish != 1 &&
            data.patient.finish != 2 &&
            data.patient.dots_app_status == 1
          "
          style="margin-left: 20px"
          :to="'/dots/visitdate/create/' + $route.params.id"
          class="btn blue darken-3"
          >Create Visit Date</router-link
        >
      </div>
      <div class="col m6" v-if="data && data.patient">
        <dot-status></dot-status>
      </div>
    </div>
    <div class="row" v-if="data">
      <div class="col m6" v-if="data.patient">
        <div class="card card-content">
          <table class="app-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>TB Code</th>
                <th>DOTS Start Date</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ data.patient && data.patient.name }}</td>
                <td>
                  {{ tbCode }}
                </td>
                <td>{{ data.patient && data.patient.dots_startdate }}</td>
                <td>{{ data.patient && data.patient.phone }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <dots-visit-date-remark
            :patient="data.patient"
          ></dots-visit-date-remark>
        </div>
      </div>
      <div class="col m6">
        <div class="card card-content">
          <ul class="collapsible" style="margin-bottom: 20px">
            <li>
              <div class="collapsible-header">
                <i class="material-icons">settings</i>Setting
              </div>
              <div class="collapsible-body">
                <div class="row">
                  <div class="col s6">
                    <span>Start Date</span>
                    <input
                      v-model.lazy="start_date"
                      type="text"
                      class="datepicker"
                    />
                  </div>
                  <div class="col s6">
                    <span>End Date</span>
                    <input
                      v-model.lazy="end_date"
                      type="text"
                      class="datepicker"
                    />
                  </div>
                  <div class="col s12 center">
                    <br />
                    <button @click="btnSearch" class="btn blue">Search</button>
                    <button @click="viewAll" class="btn blue ml-1">View All</button>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <div v-if="loading" class="center-align" style="padding: 20px;">
            <div class="preloader-wrapper small active">
              <div class="spinner-layer spinner-blue-only">
                <div class="circle-clipper left">
                  <div class="circle"></div>
                </div><div class="gap-patch">
                  <div class="circle"></div>
                </div><div class="circle-clipper right">
                  <div class="circle"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <table class="app-table">
              <thead>
                <tr>
                  <th>Nos</th>
                  <th>Date</th>
                  <th>Statuss</th>
                  <th>Volunteer</th>
                  <th>FO Edits</th>
                  <th>Pill Count</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!data.visit_dates || data.visit_dates.length === 0">
                  <td colspan="7" class="center-align">
                    No visit dates found.
                  </td>
                </tr>
                <tr v-for="(item, index) in data.visit_dates" :key="item.id" v-else>
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.date }}</td>
                  <td>
                    {{ getStatus(item.status, item.type) }}
                  </td>
                  <td>
                    <span v-if="item.volunteer"
                      >{{ item.volunteer.code }} ({{ item.volunteer.name }})</span
                    >
                  </td>
                  <td>
                    <router-link
                      :to="'/patient/dots/edit-history/' + item.id"
                      class="blue-text darken-2"
                      >{{ item.edit_histories.length }}</router-link
                    >
                    <span v-if="editHistoryLoading && editHistoryId === item.id" class="ml-1">
                      <div class="preloader-wrapper extra-small active">
                        <div class="spinner-layer spinner-blue-only">
                          <div class="circle-clipper left">
                            <div class="circle"></div>
                          </div><div class="gap-patch">
                            <div class="circle"></div>
                          </div><div class="circle-clipper right">
                            <div class="circle"></div>
                          </div>
                        </div>
                      </div>
                    </span>
                  </td>
                  <td>{{ item.status == 1 ? item.pill_count : "" }}</td>
                  <td>
                    <button
                      @click="viewVisitDateDetail(item)"
                      class="btn blue darken-3"
                    >
                      <i class="material-icons">details</i>
                    </button>
                    <button
                      style="margin-left: 10px"
                      @click="editDate(item)"
                      class="btn blue darken-3"
                    >
                      <i class="material-icons">edit</i>
                    </button>
                    <button
                      style="margin-left: 10px"
                      @click="editVisitDate(item)"
                      class="btn green darken-3"
                    >
                      <i class="material-icons">brush</i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="center-align" style="margin-top: 50px;">
      <div class="preloader-wrapper big active">
        <div class="spinner-layer spinner-blue-only">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackContainer from "@/components/ReUse/BackContainer.vue";
import VisitDateDetail from "./VisitDateDetail.vue";
import DateEditModal from "./DateEditModal.vue";
import DOTStatus from "./DOTStatus.vue";
import DOTSVisitDateRemark from "./DOTSVisitDateRemark.vue";
import EditDotsVisitDate from "./EditDotsVisitDate.vue";
import { dayDiff } from "./../../../misc/visit_date_service";
export default {
  data() {
    return {
      detailShow: false,
      dateEditShow: false,
      editInfoModalShow: false,
      detailData: null,
      start_date: "",
      end_date: "",
      editHistoryLoading: false,
      editHistoryId: null,
      dataInitialized: false,
    };
  },
  mounted() {
    var elems = document.querySelectorAll(".collapsible");
    var instances = M.Collapsible.init(elems, {});
    var elems = document.querySelectorAll(".datepicker");
    var instances = M.Datepicker.init(elems, {
      format: "yyyy-mm-dd",
      showClearBtn: true,
    });
    this.initData();
  },
  updated() {
    var elems = document.querySelectorAll(".collapsible");
    var instances = M.Collapsible.init(elems, {});
    var elems = document.querySelectorAll(".datepicker");
    var instances = M.Datepicker.init(elems, {
      format: "yyyy-mm-dd",
      showClearBtn: true,
    });
  },
  computed: {
    data() {
      return this.$store.getters.dots_visitdates;
    },
    tbCode() {
      if (
        this.data.patient.patient &&
        this.data.patient.patient.tb_conclusion.union_temporary_code_plain
      ) {
        return this.data.patient.patient.tb_conclusion
          .union_temporary_code_plain;
      }
      if (
        this.data.patient.patient &&
        this.data.patient.patient.tb_conclusion.new_tb_code_type
      ) {
        return (
          this.data.patient.patient.tb_conclusion.new_tb_code_type +
          this.data.patient.patient.tb_conclusion.new_tb_code_township +
          this.data.patient.patient.tb_conclusion.new_tb_code
        );
      }
      return this.data.patient.tb_code;
    },
    loading() {
      return this.$store.getters.dots_visitdates_loading;
    },
    action_loading() {
      return this.$store.getters.dots_visitdates_action_loading;
    },
    action_finish() {
      return this.$store.getters.dots_visitdates_action_finish;
    },
  },
  methods: {
    deleteData(id) {
      this.$store.dispatch("deleteDOTSVisitDate", {
        id: id,
      });
    },
    getStatus(status, type) {
      let parseStatus = parseInt(status);
      if(parseStatus == 1 && parseInt(type) == 4) {
        return "Skipped";
      }
      if(parseStatus == 1) {
        return "Visited"; 
      } 
      if(parseStatus == 2) {
        return "Cannot Connect";
      } 
      if(parseStatus == 0) {
        return "Pending";
      }
   
    },
    viewVisitDateDetail(data) {
      this.detailShow = true;
      this.detailData = data;
      
      // Set loading state for edit history
      this.editHistoryLoading = true;
      this.editHistoryId = data.id;
      
      this.$store.dispatch("getDOTSVisitDateEdit", {
        id: data.id
      }).then(() => {
        this.editHistoryLoading = false;
        this.editHistoryId = null;
      });
    },
    editDate(data) {
      this.dateEditShow = true;
      this.detailData = data;
    },
    editVisitDate(data) {
      this.detailData = data;
      this.editInfoModalShow = true;
    },
    canEditData(data) {
      if (dayDiff(new Date(data.date), new Date()) < 31) return true;
      else return false;
    },
    viewAll() {
      const timestamp = new Date().getTime();
      this.$router.push({
        path: `/dots/visitdate/${this.$route.params.id}`,
        query: { _: timestamp }
      })
    },
    btnSearch() {
      const timestamp = new Date().getTime();
      this.$router.push({
        path: `/dots/visitdate/${this.$route.params.id}`,
        query: {
          start_date: this.start_date,
          end_date: this.end_date,
          _: timestamp
        }
      })
    },
    initData() {
      console.log("Initializing data");
      this.$store.commit("SET_DATA", { patient: {}, visit_dates: [] });
      this.getData();
    },
    getData() {
      console.log("Getting data");
      this.$store.dispatch("getSideEffects");
      var data = {
        patient_id: this.$route.params.id,
      };
      if (this.$route.query.start_date && this.$route.query.end_date) {
        data.start_date = this.$route.query.start_date;
        data.end_date = this.$route.query.end_date;
      }
      
      this.$store.commit("SET_LOADING", true);
      console.log("Loading set to true");
      
      this.$store.dispatch("getDOTSVisitDate", data)
        .then(response => {
          console.log("Data fetched successfully:", response);
          this.dataInitialized = true;
        })
        .catch(error => {
          console.error("Error fetching DOTS visit dates:", error);
          this.$store.commit("SET_LOADING", false);
        });
    },
  },
  watch: {
    action_finish(val) {
      if (val) {
        this.$notify({
          group: "noti",
          type: "success",
          text: "Deleted",
        });
      }
    },
    $route(to, from) {
      this.getData();
    },
  },
  components: {
    "back-container": BackContainer,
    "visit-date-detail": VisitDateDetail,
    "date-edit-modal": DateEditModal,
    "dot-status": DOTStatus,
    "edit-dots-visit-data": EditDotsVisitDate,
    "dots-visit-date-remark": DOTSVisitDateRemark,
  },
};
</script>

<style lang="scss" scoped>
.cutsom_container {
  padding-left: 35px;
  padding-right: 35px;
}
.ml-1{
  margin-left: 5px;
}
.extra-small {
  width: 18px !important;
  height: 18px !important;
  vertical-align: middle;
}
.center-align {
  text-align: center;
}
</style>
